import React, { useState, useRef, useEffect } from 'react';
//import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import { withTranslation } from 'react-i18next';
import SearchByLetter from './Search/ByAlphabet/SearchByLetter'
import SearchHeader from './Search/ByNameandMeaning/SearchHeader'
import ResultTable from './Result/ResultTable'
import Error from './Common/Error'
import './BabyNameFinder.css'

// General scroll to element function
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

const BabyNameFinderForm = (props) => {

  const [componentData, setComponentData] = useState({})
  const [alpVisibleState, setAlpVisibleState] = useState(false)
  const [visibleState, setVisibleState] = useState(false)
  const [searchTerm, setSearchTerm] = useState()
  const [searchType, setSearchType] = useState()
  const [genderType, setGenderType] = useState('null')
  const [clearAlpActive, setClearAlpActive] = useState(false) 
  const [clearTermActive, setClearTermActive] = useState(false)
  const resultRef = useRef(null)
  const executeScroll = () => scrollToRef(resultRef)
  const [errorDetails, setErrorDetails] = useState({
    errorBlk: false,
    errorData: null,
    type: ''
  })
  const [alpErrorDetails, setAlpErrorDetails] = useState({
    errorBlk: false,
    errorData: null
  })

  const eventHandler = (data, type, gtype, vState) => {    
    setClearAlpActive(true)
    setClearTermActive(false)
    setSearchTerm(data)
    setSearchType(type)
    setGenderType(gtype)
    setVisibleState(false)
    setAlpVisibleState(true)
    setAlpErrorDetails({
      errorBlk : false,
      errorData: ''
    })    
  } 

  const eventDataHandler = (term, type, gender, vState) => {
    setClearAlpActive(false)
    setClearTermActive(true)
    setSearchTerm(term)
    setSearchType(type)
    setGenderType(gender)
    setAlpVisibleState(false)
    setVisibleState(true)
    setErrorDetails({
      errorBlk : false,
      errorData: '',
      type: ''
    })
  }
  
	useEffect(() => {
    setVisibleState(false)
    setVisibleState(false) 
    setAlpVisibleState(false)
    setAlpErrorDetails({
      errorBlk : false,
      errorData: ''
    })
    setErrorDetails({
      errorBlk : false,
      errorData: '',
      type: ''
    })
		if (sessionStorage.getItem('BNFLSComponentData')) {
      setComponentData(JSON.parse(sessionStorage.getItem('BNFLSComponentData')));
		} else { 
			// Calling layout service url
	    let componentData = props.fields
      sessionStorage.setItem('BNFLSComponentData', JSON.stringify(componentData));
      setComponentData(componentData); 
    }
  }, [])

  const stopSubmit = (e) => {
    e.preventDefault()
  }

  const changeAlpHandler = (result) => {
    setVisibleState(false)    
    if(result.status){
      setAlpVisibleState(false)
      setAlpErrorDetails({
        errorBlk : result.status,
        errorData: result.data
      })
    } else {      
      setAlpVisibleState(!result.status)      
    }
    executeScroll()
  }

  const changeTermHandler = (result) => {    
    setAlpVisibleState(false)
    if(result.status){
      setVisibleState(false) 
      setErrorDetails({
        errorBlk : result.status,
        errorData: result.data,
        type: result.type
      })
    }
    executeScroll()
  }
  
  if (componentData.Title){
    return(
      <React.Fragment>
        <section className="stage index m-scene UtilityWrap" id="main">
          <div className="tool-header header-detail">
            <span className="headericon">
              <i className="fa fa-child"></i>
            </span>
            <h1 className="redText">
              {componentData.Title.value}
            </h1>
          </div>   
          <div className="form-container search-form-container">
            <form className="form" onSubmit={e => stopSubmit(e) }>
              { 
                clearAlpActive && alpErrorDetails.errorBlk && 
                <Error errormsg={alpErrorDetails.errorData} />
              }
              <SearchByLetter 
                items={componentData.Alphabets} 
                label={componentData.SearchByAlphabetLabel.value} 
                inputType={componentData.SearchByAlphabetLabel}
                buttonLabel={componentData.buttonlabel}
                onFetchData = {eventHandler.bind(this)}
                clearAlpActive = {clearAlpActive}
              />              
              <div className="blk-separator">
                <span>{componentData.FormDividerText.value}</span>
                <hr />
              </div>
              <SearchHeader           
                complabel = {componentData.SearchbyLabel.value} 
                compgenderlabel = {componentData.GenderLabel.value} 
                namelink = {componentData.SearchbyNameLabel.value}
                searchnamelabel={componentData.SearchbyNameBoxLabel.value}
                meaninglink = {componentData.SearchbyMeaningLabel.value}  
                searchmeaninglabel={componentData.SearchbyMeaningBoxLabel.value}
                searchlabel = {componentData.SearchButtonLabel.value} 
                gender={componentData.Gender}                  
                onFetchData = {eventDataHandler.bind(this)}
                clearTermActive = {clearTermActive}
                errorDetails = {errorDetails}
              />
            </form>
            <div className="table-result" ref={resultRef}>
              <React.Fragment>
                { 
                  visibleState && 
                  <React.Fragment>
                    <ResultTable 
                      name={searchTerm} 
                      sType={searchType} 
                      gType={genderType}
                      resultData={() => changeTermHandler.bind(this)}
                    />                    
                  </React.Fragment>
                }   
                { 
                  alpVisibleState && 
                  <ResultTable 
                    name={searchTerm} 
                    sType={searchType} 
                    gType={genderType} 
                    resultData={() => changeAlpHandler.bind(this)}  
                  />                  
                }                  
              </React.Fragment>
            </div>
          </div>          
        </section>
    </React.Fragment>
    )    
  } else {
    return null;
  }  
}

export default withTranslation()(BabyNameFinderForm);
//export default BabyNameFinderForm
